import { DatePicker, Empty, Row } from 'antd';
import { InverterApi } from 'api/InverterApi';
import { plantApi } from 'api/plantApi';
import { useAppSelector } from 'app/hooks';
import { selectPlantItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import { inverterInfo, ResponseData, responseDataReport } from 'models';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { customDataTemperatureChart } from 'utils/common';
import ChartActivePower from '../ChartActivePower/ChartActivePower';
import style from './AreaActivePower.module.scss';
export interface AreaActivePowerProps {
  total_cum_out_e?: number;
  weatherInfor?: inverterInfo;
}

export default function AreaActivePower({ total_cum_out_e, weatherInfor }: AreaActivePowerProps) {
  const plantItemSelected = useAppSelector(selectPlantItemSidebar);
  const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
  const [weatherInfo, setWeatherInfo] = useState<any>();
  // const [newDataChartPAA, setNewDataChartPAA] = useState<responseDataChart>();
  const [newDataChartPAA, setNewDataChartPAA] = useState<responseDataReport | null>();

  useEffect(() => {
    if (weatherInfor) {
      (async () => {
        const res: any = await InverterApi.fetchStatisticByDevice({
          id: weatherInfor.id,
          text: ['temp', 'hum', 'irra'],
        });
        setWeatherInfo(res);
      })();
    }
  }, [weatherInfor]);

  useEffect(() => {
    if (plantItemSelected) {
      setDate(moment().format('YYYY-MM-DD'));
    }
  }, [plantItemSelected]);
  useEffect(() => {
    if (plantItemSelected && weatherInfor) {
      fetchDataChart(plantItemSelected, weatherInfor.id, date);
    }
  }, [plantItemSelected, weatherInfor, date]);

  const fetchDataChart = async (plantId: string, weatherId: string, date: string) => {
    let newDA;
    try {
      const response: ResponseData[] = await plantApi.fetchPropertiesPlant({
        type: 'output-power/avg-per-ten-mins',
        id: plantId,
        time: date,
      });
      const outPut_power = await formatDataChart(response);
      const resOne: any = await InverterApi.fetchDataInverterGraph({
        id: weatherId,
        text: ['irra'],
        start_ts: moment(date).startOf('day').valueOf(),
        end_ts: moment(date).endOf('day').valueOf(),
        duration: 600000,
      });
      newDA = await customDataTemperatureChart(
        outPut_power,
        Object.keys(resOne).findIndex((item) => item === 'irra') !== -1
          ? customDataChart(resOne['irra'])
          : [],
        Object.keys(resOne).findIndex((item) => item === 'temp') !== -1
          ? customDataChart(resOne['temp'])
          : []
      );
    } catch (error) {
      newDA = null;
    }
    setNewDataChartPAA(newDA);
  };

  const customDataChart = (array: ResponseData[]) => {
    let newList: ResponseData[] = [];
    array.map((item) => {
      let newObject = {
        ts: Math.floor(item.ts / 600000) * 600000,
        value: item.value,
      };
      return (newList = [...newList, newObject]);
    });
    return newList;
  };

  const formatDataChart = (array: ResponseData[]) => {
    if (array.length === 0) return [];
    let newList: ResponseData[] = [];
    array.map((item) => {
      if (item.value !== null) {
        let newObject = {
          ts: item.ts,
          value: parseFloat((item.value / 1000).toFixed(3)),
        };
        return (newList = [...newList, newObject]);
      } else {
        return (newList = [...newList, item]);
      }
    });
    return newList;
  };

  const disabledDate = (current: any) => {
    return current && current > moment().endOf('day');
  };

  const onChangeDatePicker = async (date: any, dateString: string) => {
    await setDate(moment(dateString).format('YYYY-MM-DD'));
  };

  return (
    <div className={style.root}>
      <div className={style.active_power_chart}>
        <div className={style.header_chart}>
          <DatePicker
            disabledDate={disabledDate}
            picker="date"
            value={moment(date)}
            onChange={onChangeDatePicker}
          />
        </div>
        {newDataChartPAA ? (
          <ChartActivePower
            isReport={false}
            newDataChartPAA={newDataChartPAA}
            date={date}
            setDate={setDate}
          />
        ) : (
          <div className={style.no_data_chart}>
            <Empty />
          </div>
        )}
      </div>
      <div className={style.report_plant}>
        <div className={style.revenue_plant}>
          <div className={style.title_report_plant}>
            <div className={style.title_report_plant_left}>
              <div
                className={style.total_alarms}
                style={{
                  backgroundColor: weatherInfor?.active ? '#61C409' : 'red',
                }}
              ></div>
              <div>Weather</div>
            </div>
            {weatherInfor?.active && weatherInfo ? (
              <div className={style.title_report_plant_right}>
                Updated at: {moment(weatherInfo.hum[0].time).format('YYYY-MM-DD HH:mm:ss')}
              </div>
            ) : (
              <div className={style.title_report_plant_right}>
                Disconnect at:{' '}
                {moment(weatherInfor?.last_disconnect_time).format('YYYY-MM-DD HH:mm:ss')}
              </div>
            )}
          </div>
          <div className={style.content_item_report}>
            <div className={style.title_item}>
              <div className={style.icon_today_revenue}></div>
              Temperature
            </div>
            <div className={style.value_item} style={{ color: '#faad14' }}>
              {weatherInfor?.active && weatherInfo ? `${weatherInfo.temp[0].value} °C` : `N/A`}
            </div>
          </div>
          <div className={style.content_item_report}>
            <div className={style.title_item}>
              <div className={style.icon_month_revenue}></div>
              Humidity
            </div>
            <div className={style.value_item} style={{ color: '#40a9ff' }}>
              {weatherInfor?.active && weatherInfo ? `${weatherInfo.hum[0].value} %` : `N/A`}
            </div>
          </div>
          <div className={style.content_item_report}>
            <div className={style.title_item}>
              <div className={style.icon_year_revenue}></div>
              Solar Irradiance
            </div>
            <div className={style.value_item} style={{ color: '#f26464' }}>
              {!weatherInfor?.active ? (
                <div>N/A</div>
              ) : (
                <div>
                  {weatherInfo && weatherInfo.irra[0].value} W/m<sup>2</sup>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={style.environmental_plant}>
          <div className={style.title_report_plant}>Environment & Economic Benefits</div>
          <div className={style.content_item_environmental}>
            <div className={style.icon_item_environmental}>
              <div className={style.icon_co2_environmental}></div>
            </div>
            <div className={style.value_item_environmental}>
              <div className={style.title_item_environmental}>
                Giảm xả thải khí CO<sub>2</sub>
              </div>
              <div className={style.value_environmental} style={{ color: '#ff7900' }}>
                {total_cum_out_e
                  ? `${(total_cum_out_e * 0.000709).toLocaleString(undefined, {
                      maximumFractionDigits: 0,
                    })} Tấn`
                  : `N/A`}
              </div>
            </div>
          </div>
          <div className={style.content_item_environmental}>
            <div className={style.icon_item_environmental}>
              <div className={style.icon_cola_environmental}></div>
            </div>
            <div className={style.value_item_environmental}>
              <div className={style.title_item_environmental}>Hiệu quả tương đương trồng</div>
              <div className={style.value_environmental} style={{ color: '#01a84e' }}>
                {total_cum_out_e
                  ? `${(total_cum_out_e * 0.011816667).toLocaleString(undefined, {
                      maximumFractionDigits: 0,
                    })} Cây`
                  : `N/A`}
              </div>
            </div>
          </div>
          <div className={style.content_item_environmental}>
            <div className={style.icon_item_environmental}>
              <div className={style.icon_park_environmental}></div>
            </div>
            <div className={style.value_item_environmental}>
              <div className={style.title_item_environmental}>Giảm sử dụng than</div>
              <div className={style.value_environmental}>
                {total_cum_out_e
                  ? `${(total_cum_out_e * 0.001414455).toLocaleString(undefined, {
                      maximumFractionDigits: 0,
                    })} Tấn`
                  : `N/A`}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
